// @flow
import React from "react";
import List from "@material-ui/core/List";
import LocationListItem from "../../components/LocationListItem";

function TicketReservationLocation({ gameId }) {
  return (
    <List>
      <LocationListItem gameId={gameId} />
    </List>
  );
}

export default TicketReservationLocation;
